export enum ProjectEligibilities {
  SETTER_SALES_PRO = "Setter / Sales Pro",
  CLOSER = "Closer",
  TEAM_BUILDER = "Team Builder",
  ORG_STAFF = "Org Staff",
}

export enum UserAutocompletePathEnum {
  SETTER = "/users/project_consultants",
  CLOSER = "/users/project_mentors",
  AMBASSADOR = "/users/project_ambassadors",
  MANAGER = "/users/project_coordinators",
  LEAD_REFERRER = "/users/lead_person_lookup",
  ROOFING_DESIGNERS = "/users/roofing_designers",
  ENTERPRISE_USER = "/enterprise/enterprise_users_autocomplete",
  TEAM_INTELLIGENCE_USER = "/team_intelligence/autocomplete",
  ADMIN = "/users",
}

export enum EnterpriseCompModelEnum {
  COGS = "default_cogs",
  POWUR_LINE = "powurline",
  HOLDBACK = "holdback",
}

export enum ProjectCompModelEnum {
  COGS = "standard",
  POWUR_LINE = EnterpriseCompModelEnum.POWUR_LINE,
  HOLDBACK = EnterpriseCompModelEnum.HOLDBACK,
}

export const COMPTYPE_LABEL_MAP: Record<EnterpriseCompModelEnum, string> = {
  [EnterpriseCompModelEnum.COGS]: "",
  [EnterpriseCompModelEnum.POWUR_LINE]: "PowurLine",
  [EnterpriseCompModelEnum.HOLDBACK]: "Fixed Holdback",
};
